module.exports = __webpack_public_path__ + "static/media/gb.c39480d5.svg";